import { useCallback, useEffect, useState } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { useDebounce } from '../../../../hooks/use-debounce';
import { useDialog } from '../../../../hooks/use-dialog';
import { usePageParam } from '../../../../hooks/search-params/use-page-param';
import { useSyncQueryParamToState } from '../../../../hooks/search-params/use-sync-query-param-to-state';
import { useFiltersParam } from './use-filters-param';
import { useQueryInputParams } from './use-query-input-param';

export const useContractsFilters = () => {
  const [queryParam, setQueryParam] = useQueryInputParams();
  const [query, setQuery] = useState(queryParam ?? '');
  const debouncedQuery = useDebounce(query);
  const [filters, setFilters] = useFiltersParam();
  const [, setPage] = usePageParam();

  const {
    isDialogOpen: isFilterContractsOpen,
    handleOpen: openFilterContracts,
    handleClose: closeFilterContracts,
  } = useDialog();

  useEffect(() => {
    setQueryParam(debouncedQuery);
  }, [debouncedQuery]);

  useSyncQueryParamToState(queryParam, setQuery);

  const handleSearchInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(event.target.value);
    },
    [],
  );

  const handleFilterClick = useCallback(
    (filterLines: FilterLineType[]) => {
      setFilters(filterLines);
      setPage(0);
    },
    [],
  );

  return {
    query: queryParam,
    inputValue: query,
    handleSearchInputChange,
    filters,
    handleFilterClick,
    isFilterContractsOpen,
    openFilterContracts,
    closeFilterContracts,
  };
};
